import { Card, Tabs, Tooltip } from "flowbite-react";
import MainLayout from "../../layout/MainLayout";

import "./about-page.css";
import { ReactTyped } from "react-typed";
import {
  BriefcaseIcon,
  DownloadIcon,
  GraduateCapIcon,
} from "../../components/icons/icons";
import {
  flowbiteCustomCardThemeConfig,
  flowbiteCustomTabsThemeConfig,
} from "../../shared/flowbiteThemeConfig";

function AboutPage() {
  interface Expertise {
    imgLink: string;
    title: string;
  }

  interface Experience {
    workplace: string;
    designation: string;
    yearActive: string;
    icon: () => JSX.Element;
    expDetail: Array<any>;
  }

  const languages: Expertise[] = [
    {
      imgLink: "assets/icons/html.png",
      title: "HTML 5",
    },
    {
      imgLink: "assets/icons/css3.png",
      title: "CSS 3",
    },
    {
      imgLink: "assets/icons/js.svg",
      title: "JavaScript ES6+",
    },
    {
      imgLink: "assets/icons/typescript.svg",
      title: "TypeScript",
    },
  ];

  const frames: Expertise[] = [
    {
      imgLink: "assets/icons/jquery.png",
      title: "jQuery",
    },
    {
      imgLink: "assets/icons/angular.svg",
      title: "Angular 14+ to latest",
    },
    {
      imgLink: "assets/icons/react.svg",
      title: "React 18+",
    },
    {
      imgLink: "assets/icons/nextjs.svg",
      title: "NextJs",
    },
  ];

  const styles: Expertise[] = [
    {
      imgLink: "assets/icons/bootstrap.svg",
      title: "Bootstrap 4 & 5+",
    },
    {
      imgLink: "assets/icons/sass.svg",
      title: "SCSS",
    },
    {
      imgLink: "assets/icons/tailwind.svg",
      title: "Tailwind CSS",
    },
    {
      imgLink: "assets/icons/flowbite.svg",
      title: "Flowbite & React Flowbite",
    },
    {
      imgLink: "assets/icons/daisyui.png",
      title: "DaisyUI",
    },
  ];

  const designExps: Expertise[] = [
    {
      imgLink: "assets/icons/photoshop-cc.svg",
      title: "Adobe PhotoShop CC",
    },
    {
      imgLink: "assets/icons/illustrator.svg",
      title: "Adobe Illustrator CC",
    },
    {
      imgLink: "assets/icons/figma.svg",
      title: "Figma",
    },
    {
      imgLink: "assets/icons/xd.svg",
      title: "Adobe XD",
    },
  ];

  const otherExps: Expertise[] = [
    {
      imgLink: "assets/icons/git.png",
      title: "Git version control",
    },
    {
      imgLink: "assets/icons/github.svg",
      title: "GitHub",
    },
    {
      imgLink: "assets/icons/gitlab.svg",
      title: "GitLab",
    },
    {
      imgLink: "assets/icons/office.png",
      title: "Microsoft Office tools",
    },
  ];

  const workExps: Experience[] = [
    {
      workplace: "Mind Orbital Technologies Inc.",
      designation: "Web Designer",
      yearActive: "March 2023 - 2025",
      icon: () => <BriefcaseIcon />,
      expDetail: [
        "Working on web designing since 2 years.",
        "SEO-friendly website building.",
        "Cross-browser compatible website designing.",
        "Expertise on Bootstrap custom theming.",
        "Excellent teamwork capabilities.",
        "Worked on service based websites.",
      ],
    },
    {
      workplace: "Stamford University Bangladesh",
      designation: "Bachelor in EEE",
      yearActive: "December 2022",
      icon: () => <GraduateCapIcon />,
      expDetail: ["CGPA: 3.67"],
    },
    {
      workplace: "Bangladesh Navy College, Chittagong",
      designation: "Higher Secondary Certificate",
      yearActive: "October 2015",
      icon: () => <GraduateCapIcon />,
      expDetail: ["GPA: 4.42"],
    },
  ];

  const typedStrings = ["Web Developer.", "Frontend Designer."];

  return (
    <MainLayout>
      <Card className="bg-gray-700 about-me-card lg:max-w-[60rem] mx-auto border-gray-600 lg:mt-8 md:mt-4 mt-2 lg:py-16 md:py-10 py-8">
        <div className="text-center lg:text-3xl md:text-2xl text-xl font-bold text-white">
          <span className="me-1.5">I am a</span>
          <ReactTyped
            strings={typedStrings}
            typeSpeed={60}
            backSpeed={45}
            loop={true}
            backDelay={1500}
            smartBackspace={false}
          />
        </div>
        <p className="text-center max-w-[24rem] mx-auto">
          <span className="text-lg font-medium">
            Hello! My name is Md. Salman Ezaz.
          </span>
          <span className="text-sm my-2 block">
            I am a Web Developer and professional Frontend Designer. <br /> I
            have more than <span className="font-bold">two years</span> of
            experience in <span className="font-bold">Frontend Designing</span>,{" "}
            <span className="font-bold">one year</span> experience working on{" "}
            <span className="font-bold">MERN Stack web development</span> and I
            have completed many official and self projects within this time.
          </span>
        </p>
        <div className="text-center">
          <a
            className="px-4 py-2 rounded-md border border-gray-600 shadow-sm-light shadow-gray-600 hover:bg-gray-900 hover:shadow-gray-900 hover:border-gray-800 transition-all"
            target="_blank"
            href="assets/docs/Resume_Md_Salman_Ezaz.pdf"
          >
            <div className="flex">
              <DownloadIcon />
              <span className="ms-2">Download My CV</span>
            </div>
          </a>
        </div>
      </Card>
      <p className="text-center mt-16">
        <span className="bg-gray-900 py-2 px-4 rounded-lg bg-opacity-50">
          Work and Education history
        </span>
      </p>
      <div className="my-12 flex flex-wrap px-1 justify-center">
        {workExps.map((workExp, index) => (
          <div
            key={index}
            className="md:w-[50%] w-[24rem] sm:w-full xl:w-[calc(100%/3)] px-1 mb-3 xl:mb-0"
          >
            <Card
              className="bg-gray-900 border-gray-700 career-card relative h-full"
              theme={flowbiteCustomCardThemeConfig}
            >
              <div className="flex items-end pb-[10px] justify-center badge w-10 h-16 text-gray-200 bg-gray-700 rounded-b-full absolute top-0 end-4">
                {workExp.icon()}
              </div>
              <div>
                <h2 className="text-xl text-white font-semibold pe-12">
                  {workExp.designation}
                </h2>
                <p className="text-xs mb-3">{workExp.yearActive}</p>
                <h3 className="text-sm">{workExp.workplace}</h3>
                <ul
                  className={`${
                    workExp.expDetail.length > 1
                      ? "list-disc ms-4"
                      : "font-semibold"
                  } text-xs mt-6`}
                >
                  {workExp.expDetail.map((detail, index) => (
                    <li key={index} className="mb-1">
                      {detail}
                    </li>
                  ))}
                </ul>
              </div>
            </Card>
          </div>
        ))}
      </div>

      <div>
        <div className="mt-16 mb-14 text-center">
          <span className="bg-gray-900 py-2 px-4 rounded-lg bg-opacity-50">
            My area of expertise
          </span>
        </div>
        <Tabs
          aria-label="Default tabs"
          variant="default"
          theme={flowbiteCustomTabsThemeConfig}
        >
          <Tabs.Item active title="Languages">
            <div className="flex flex-wrap justify-center max-w-[30rem] lg:max-w-[48rem] mx-auto">
              {languages.map((exp, index) => (
                <div
                  key={index}
                  className="md:w-[25%] w-[calc(100%/3)] aspect-square sm:aspect-auto sm:px-4 sm:pb-8"
                >
                  <div className="group relative sm:h-full sm:w-full aspect-square sm:aspect-auto border border-gray-700 lg:p-8 sm:p-4 p-6 rounded-lg m-1 bg-gray-700 hover:bg-gray-500 transition-all">
                    <img
                      src={exp.imgLink}
                      alt="img-link"
                      className="w-full h-full object-contain"
                    />
                    <div className="absolute top-3 right-3 text-nowrap">
                      <Tooltip content={exp.title}>
                        <div className="md:flex hidden opacity-0 group-hover:opacity-100 w-5 h-5 text-sm items-center justify-center rounded-full border border-gray-300 text-gray-300 hover:bg-gray-300 hover:text-gray-700 cursor-pointer transition-all ">
                          i
                        </div>
                      </Tooltip>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Tabs.Item>
          <Tabs.Item title="Frameworks & Libraries">
            <div className="flex flex-wrap justify-center max-w-[30rem] lg:max-w-[48rem] mx-auto">
              {frames.map((exp, index) => (
                <div
                  key={index}
                  className="md:w-[25%] w-[calc(100%/3)] aspect-square sm:aspect-auto sm:px-4 sm:pb-8"
                >
                  <div className="group relative sm:h-full sm:w-full aspect-square sm:aspect-auto border border-gray-700 lg:p-8 sm:p-4 p-6 rounded-lg m-1 bg-gray-700 hover:bg-gray-500 transition-all">
                    <img
                      src={exp.imgLink}
                      alt="img-link"
                      className="w-full h-full object-contain"
                    />
                    <div className="absolute top-3 right-3 text-nowrap">
                      <Tooltip content={exp.title}>
                        <div className="md:flex hidden opacity-0 group-hover:opacity-100 w-5 h-5 text-sm items-center justify-center rounded-full border border-gray-300 text-gray-300 hover:bg-gray-300 hover:text-gray-700 cursor-pointer transition-all ">
                          i
                        </div>
                      </Tooltip>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Tabs.Item>
          <Tabs.Item title="Styling Languages">
            <div className="flex flex-wrap justify-center max-w-[30rem] lg:max-w-[48rem] mx-auto">
              {styles.map((exp, index) => (
                <div
                  key={index}
                  className="md:w-[25%] w-[calc(100%/3)] aspect-square sm:aspect-auto sm:px-4 sm:pb-8"
                >
                  <div className="group relative sm:h-full sm:w-full aspect-square sm:aspect-auto border border-gray-700 lg:p-8 sm:p-4 p-6 rounded-lg m-1 bg-gray-700 hover:bg-gray-500 transition-all">
                    <img
                      src={exp.imgLink}
                      alt="img-link"
                      className="w-full h-full object-contain"
                    />
                    <div className="absolute top-3 right-3 text-nowrap">
                      <Tooltip content={exp.title}>
                        <div className="md:flex hidden opacity-0 group-hover:opacity-100 w-5 h-5 text-sm items-center justify-center rounded-full border border-gray-300 text-gray-300 hover:bg-gray-300 hover:text-gray-700 cursor-pointer transition-all ">
                          i
                        </div>
                      </Tooltip>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Tabs.Item>
          <Tabs.Item title="Design Tools">
            <div className="flex flex-wrap justify-center max-w-[30rem] lg:max-w-[48rem] mx-auto">
              {designExps.map((designExp, index) => (
                <div
                  key={index}
                  className="md:w-[25%] w-[calc(100%/3)] aspect-square sm:aspect-auto sm:px-4 sm:pb-8"
                >
                  <div className="group relative sm:h-full sm:w-full aspect-square sm:aspect-auto border border-gray-700 lg:p-8 sm:p-4 p-6 rounded-lg m-1 bg-gray-700 hover:bg-gray-500 transition-all">
                    <img
                      src={designExp.imgLink}
                      alt="img-link"
                      className="w-full h-full object-contain"
                    />
                    <div className="absolute top-3 right-3 text-nowrap">
                      <Tooltip content={designExp.title}>
                        <div className="md:flex hidden opacity-0 group-hover:opacity-100 w-5 h-5 text-sm items-center justify-center rounded-full border border-gray-300 text-gray-300 hover:bg-gray-300 hover:text-gray-700 cursor-pointer transition-all ">
                          i
                        </div>
                      </Tooltip>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Tabs.Item>
          <Tabs.Item title="Others">
            <div className="flex flex-wrap justify-center max-w-[30rem] lg:max-w-[48rem] mx-auto">
              {otherExps.map((designExp, index) => (
                <div
                  key={index}
                  className="md:w-[25%] w-[calc(100%/3)] aspect-square sm:aspect-auto sm:px-4 sm:pb-8"
                >
                  <div className="group relative sm:h-full sm:w-full aspect-square sm:aspect-auto border border-gray-700 lg:p-8 sm:p-4 p-6 rounded-lg m-1 bg-gray-700 hover:bg-gray-500 transition-all">
                    <img
                      src={designExp.imgLink}
                      alt="img-link"
                      className="w-full h-full object-contain"
                    />
                    <div className="absolute top-3 right-3 text-nowrap">
                      <Tooltip content={designExp.title}>
                        <div className="md:flex hidden opacity-0 group-hover:opacity-100 w-5 h-5 text-sm items-center justify-center rounded-full border border-gray-300 text-gray-300 hover:bg-gray-300 hover:text-gray-700 cursor-pointer transition-all ">
                          i
                        </div>
                      </Tooltip>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Tabs.Item>
        </Tabs>

        <div className="mt-16 mb-14 text-center">
          <span className="bg-gray-900 py-2 px-4 rounded-lg bg-opacity-50">
            My skills in details
          </span>
        </div>
        <div className="max-w-[30rem] lg:max-w-[60rem] mx-auto mb-8">
          <div className="flex flex-wrap lg:flex-nowrap mb-10">
            <p className="w-full lg:w-64 mb-4 lg:mb-0">
              <span className="px-4 py-2 rounded-md bg-gray-900 bg-opacity-50">
                Web Development
              </span>
            </p>
            <ul className="list-disc md:w-[calc(100%-16rem)]">
              <li className="mb-2">
                Proficient in modern web development with HTML5, CSS3,
                JavaScript (ES6+) and TypeScript.
              </li>
              <li className="mb-2">
                Skilled in managing API requests with Axios and TanStack Query,
                and handling global state using Zustand and also using React
                Context Providers.
              </li>
              <li className="mb-2">
                Proficient in handling client side forms and related validations
                using React Hook Form.
              </li>
              <li className="mb-2">
                Experienced in building backend services with Express.js and
                performing full CRUD operations with MongoDB and Mongoose.
              </li>
              <li className="mb-2">
                Experienced with frameworks and libraries like{" "}
                <span className="font-bold">React</span>,{" "}
                <span className="font-bold">Next.js</span>, and{" "}
                <span className="font-bold">Angular.</span>
              </li>
              <li className="mb-2">
                Skilled in enhancing UI/UX with jQuery, CoreUI, Bootstrap,
                Tailwind CSS, Flowbite, and Daisy UI.
              </li>
              <li>
                Experienced UI enhancement using AOS, Swiper, Sweet Alert 2,
                React Hot Toast etc.
              </li>
            </ul>
          </div>
          <div className="flex flex-wrap lg:flex-nowrap mb-10">
            <p className="w-full lg:w-64 mb-4 lg:mb-0">
              <span className="px-4 py-2 rounded-md bg-gray-900 bg-opacity-50">
                Version Control
              </span>
            </p>
            <ul className="list-disc md:w-[calc(100%-16rem)]">
              <li>
                Expertise in Git, including branching, merging, and repository
                management to streamline collaborative workflows.
              </li>
            </ul>
          </div>
          <div className="flex flex-wrap lg:flex-nowrap mb-10">
            <p className="w-full lg:w-64 mb-4 lg:mb-0">
              <span className="px-4 py-2 rounded-md bg-gray-900 bg-opacity-50">
                CMS Expertise
              </span>
            </p>
            <ul className="list-disc md:w-[calc(100%-16rem)]">
              <li>
                Hands-on experience with Payload CMS for developing and managing
                content-driven websites.
              </li>
            </ul>
          </div>
          <div className="flex flex-wrap lg:flex-nowrap mb-10">
            <p className="w-full lg:w-64 mb-4 lg:mb-0">
              <span className="px-4 py-2 rounded-md bg-gray-900 bg-opacity-50">
                Design Tools
              </span>
            </p>
            <ul className="list-disc md:w-[calc(100%-16rem)]">
              <li>
                Proficient in visual and graphic design using Photoshop,
                Illustrator, and Figma for web and print media.
              </li>
            </ul>
          </div>
          <div className="flex flex-wrap lg:flex-nowrap mb-10">
            <p className="w-full lg:w-64 mb-4 lg:mb-0">
              <span className="px-4 py-2 rounded-md bg-gray-900 bg-opacity-50">
                Office Productivity
              </span>
            </p>
            <ul className="list-disc md:w-[calc(100%-16rem)]">
              <li>
                Advanced skills in Microsoft Word, Excel, and PowerPoint for
                creating documents, analyzing data, and delivering
                presentations.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default AboutPage;
